import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { useActiveGenre } from "../../../../utils/Genre/activeGenreState";

export default function ShowAwardsList({ showAwards }) {
  const [activeGenre] = useActiveGenre();

  useEffect(() => {
    // console.log("showAwards", showAwards);
  }, [showAwards]);

  const AwardLabels = ({ winner, honoree }) => {
    return (
      <>
        {winner ? (
          <div className="award-label">
            <div className="ms-auto award-label-line red-line" />
            <div className="px-2 red">WINNER</div>
            <div className="me-auto award-label-line red-line" />
          </div>
        ) : null}

        {honoree ? (
          <div className="award-label" style={{ opacity: 0.5 }}>
            <div className="ms-auto award-label-line" />
            <div className="px-2">HONOREE</div>
            <div className="me-auto award-label-line" />
          </div>
        ) : null}
      </>
    );
  };

  return (
    <>
      {showAwards?.map((c, i) => (
        <div className="competition-container" key={i}>
          <div className="competition-title d-flex justify-content-center">
            <div className="competition-title-inner">{c.name}</div>
          </div>
          {c.program.length ? (
            c.program.map((a, i) => (
              <div key={i} className="award-category">
                <div className="award-category-name">{a.awardName}</div>
                <AwardLabels winner={a.winner} honoree={a.honoree} />
              </div>
            ))
          ) : (
            <></>
          )}
          {c.individual.length ? (
            c.individual.map((a, i) => (
              <div key={i} className="award-category">
                <div className="award-category-name">{a.awardName}</div>
                <div className="award-recipient-name">{a.name}</div>
                <AwardLabels winner={a.winner} honoree={a.honoree} />
              </div>
            ))
          ) : (
            <></>
          )}
          {c.group.length ? (
            c.group.map((a, i) => (
              <div key={i} className="award-category">
                <div className="award-category-name">{a.awardName}</div>
                <div className="award-title-name">{a.name}</div>
                {a.cast.length ? (
                  a.cast.map((cast, i) => (
                    <span key={i} className="award-recipient-name">
                      {i > 0 ? ", " : ""}
                      {cast.name}
                    </span>
                  ))
                ) : (
                  <></>
                )}
                <AwardLabels winner={a.winner} honoree={a.honoree} />
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
      ))}
    </>
  );
}
